import { checkIfLoggedIn, getCachedAccessToken } from "@wantable/Shared"

// these match the values in wantable-2/ShopifyAutoLogin
const UID_PARAM = 'shid'
const TOKEN_PARAM = 'shtn'

// we want to change links that point to the wrong environment so modify links pointing to all environments
const selector = [
  'a[href*="staging.wantable.com"]', 'a[href*="staging.wantable.com"] *',
  'a[href*="www.wantable.com"]', 'a[href*="www.wantable.com"] *',
  'a[href*="//wantable.com"]', 'a[href*="//wantable.com"] *'
].join(', ')

let currentDomain = document.domain;
let otherDomain = 'https://staging.wantable.com';

if(currentDomain === 'shop.wantable.com'){
  otherDomain = 'https://www.wantable.com';
} else if(currentDomain === '127.0.0.1'){
  otherDomain = 'http://localhost:3010';
}

window.onload = () => {
  document.addEventListener('click', function(event) {
    if (event.target.matches(selector)) {
      if(!checkIfLoggedIn()){
        return;
      }

      let anchor = event.target.closest(selector);
      let href = anchor.getAttribute('href');

      // link was already modified so allow the default event
      if(href.indexOf(UID_PARAM) >= 0){
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const tokenData = getCachedAccessToken();

      let url = new URL(href);

      url.searchParams.set(UID_PARAM, tokenData.shopifyUID);
      url.searchParams.set(TOKEN_PARAM, tokenData.shopifyToken.token);
      anchor.setAttribute('href', url.toString().replace(url.origin, otherDomain));

      // retrigger click on the modified link
      // this is preferred over setting window.lacation = url here so that the anchor target is preserved
      // and any other link modification that is setup in this theme also can function
      anchor.click();
    }
  }, false);
}
